import {FC, useEffect, useState} from 'react'
import Select, {SelectComponentsConfig} from 'react-select'
import GIcon from 'src/app/components/Libs/Icon/GIcon'
import {LabelValueProps} from '../../Libs/Form/Custom/CustomReactSelect'
import {CustomReactMultiSelect, hardClassName, SelectedValue} from './OutsideComponent'

interface Props {
  title: any
  selected: any
  setSelected: any
  defaultValue?: any
  options?: LabelValueProps[]
}

const OutsideSelectFilterLocal: FC<Props> = ({
  title,
  selected,
  setSelected,
  defaultValue,
  options,
}) => {
  const [isShow, setIsShow] = useState(false)

  const handleRemoveValue = (value: any) => {
    const removedValue = selected.find((val: any) => val.value === value)
    if (!removedValue) return
    setSelected(selected.filter((val: any) => val.value !== value))
  }

  useEffect(() => {
    if (selected?.length === 0) {
      const data = options?.filter((opt) => defaultValue.includes(opt.value))
      setSelected(data)
    }
    //eslint-disable-next-line
  }, [])

  return (
    <div className='relative'>
      <div className='flex items-center space-x-2 font-normal text-fs-9 text-neutral-500'>
        <div>{title}</div>
        <div onClick={() => setIsShow((prev) => !prev)}>
          <GIcon icon='IconAddRounded' className='w-6 h-6 cursor-pointer' />
        </div>
      </div>

      {selected?.length > 0 && (
        <SelectedValue selected={selected} handleRemoveValue={handleRemoveValue} />
      )}

      {isShow && (
        <div className='absolute left-0 z-10 w-full p-4 bg-white border-b rounded-t shadow border-neutral-100'>
          <div
            className='fixed top-0 bottom-0 left-0 right-0'
            onClick={() => setIsShow((prev) => !prev)}
          ></div>
          <Select
            autoFocus
            options={options}
            isMulti
            menuIsOpen
            defaultValue={defaultValue}
            defaultMenuIsOpen={true}
            placeholder='Cari'
            onChange={(val) => {
              setSelected(val)
              setIsShow(false)
            }}
            value={selected}
            classNames={hardClassName}
            components={CustomReactMultiSelect as SelectComponentsConfig<any, any, any>}
            controlShouldRenderValue={false}
            menuPortalTarget={document.querySelector('body')}
          />
        </div>
      )}
    </div>
  )
}

export default OutsideSelectFilterLocal
